var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5849 27.6758L21.8462 19.9371C26.0735 14.653 25.2212 6.9144 19.9371 2.68713C14.653 -1.54014 6.9144 -0.687872 2.68713 4.59622C-1.54014 9.88031 -0.687872 17.6189 4.59622 21.8462C6.77804 23.5849 9.47122 24.5394 12.2667 24.5394C15.0621 24.5394 17.7553 23.5849 19.9371 21.8462L27.6758 29.5849C28.1871 30.0962 29.0053 30.1303 29.5508 29.6189L29.5849 29.5849C30.0962 29.0735 30.0621 28.2212 29.5849 27.6758ZM12.2667 21.8121C6.98258 21.8121 2.72122 17.5508 2.72122 12.2667C2.72122 6.98258 6.98258 2.72122 12.2667 2.72122C17.5508 2.72122 21.8121 6.98258 21.8121 12.2667C21.8121 17.5508 17.5508 21.8121 12.2667 21.8121Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a386a5a1d32e0b8f10137f8924501f25.svg";
export { ForwardRef as ReactComponent };